import * as React from 'react';

import {LoadingPage} from 'shells/loading-page/loading-page';
import {SectionLabel} from 'shells/typography/section-label';

import {UpsellButton} from '../../../client_modules/shells/react/components/button/upsell-button/upsell-button';

import {AccountHierarchyFeatureGateModal} from '../../limits/feature-gates/account-hierarchy-feature-gate-modal';

import styles from './account-hierarchy.module.css';

type Props = {
    isLoading: boolean;
};

export function AccountHierarchyFeatureGate(props: Props) {
    const [isShowingUpgradeModal, setIsShowingUpgradeModal] = React.useState<boolean>(false);

    return (
        <div className={styles.container}>
            <SectionLabel>
                <div className={styles.header}>{props.isLoading ? null : 'Company hierarchy'}</div>
            </SectionLabel>
            {props.isLoading && <LoadingPage />}
            <UpsellButton
                onClick={() => {
                    setIsShowingUpgradeModal(true);
                }}
                text='Upgrade'
            />
            <AccountHierarchyFeatureGateModal
                isOpen={isShowingUpgradeModal}
                onClose={() => setIsShowingUpgradeModal(false)}
            />
        </div>
    );
}
